import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';

import Loader from 'src/components/common/loader';

import paymentStore from 'src/stores/payment-store';
import popupStore from 'src/stores/popup-store';

import useSluggedNavigate from 'src/hooks/use-slugged-navigate';
import {
  AppRoute,
  LOCALES,
  MeshulamAction,
  MeshulamLink,
  PaymentType,
  PopupName,
} from 'src/constants';

import './meshulam-form.scss';

interface FormParams {
  url: string;
  orderNo: string;
}

const MeshulamForm = observer(() => {
  const [formParams, setFormParams] = useState<FormParams | null>(null);
  const navigate = useSluggedNavigate();

  useEffect(() => {
    const handlePaymentError = () => navigate(AppRoute.CHECKOUT_PAGE_ROUTE);

    const getFormUrl = async () => {
      const { payment_url, no } = await paymentStore.createOrder(
        PaymentType.MESHULAM,
        handlePaymentError
      );
      if (payment_url) {
        setFormParams({
          url: payment_url,
          orderNo: no,
        });
      }
    };

    void getFormUrl();
  }, [navigate]);

  useEffect(() => {
    const listenBrowserMessages = (result: any) => {
      if (result.origin === MeshulamLink.TEST || result.origin === MeshulamLink.PROD) {
        switch (result.data.action) {
          case MeshulamAction.CLOSE: {
            navigate(AppRoute.CHECKOUT_PAGE_ROUTE);
            break;
          }
          case MeshulamAction.PAYMENT: {
            if (result.data.status === 1 && formParams) {
              paymentStore.setPaidOrderNumber(formParams.orderNo);
              navigate(`${AppRoute.PAYMENT_RESULT_PAGE_ROUTE}/${formParams.orderNo}`);
            }
            break;
          }
          case MeshulamAction.FAILED_LOAD: {
            popupStore.showPopup(PopupName.INFO, {
              title: LOCALES.PAYMENT_ERROR,
              text: LOCALES.PAYMENT_FORM_EXPIRED,
            });
            navigate(AppRoute.CHECKOUT_PAGE_ROUTE);
            break;
          }
        }
      }
    };

    if (formParams) {
      window.addEventListener('message', listenBrowserMessages);
    }

    return () => window.removeEventListener('message', listenBrowserMessages);
  }, [formParams, navigate]);

  return (
    <div className="meshulam-form">
      {formParams ? (
        <iframe
          className="meshulam-form__frame"
          width={520}
          height={728}
          src={formParams.url}
          title={LOCALES.PAYMENT}
        />
      ) : (
        <Loader />
      )}
    </div>
  );
});

export default MeshulamForm;
